import { Link } from 'react-router-dom';
import type { LinkLikeComponentProps } from '@shopify/polaris/build/ts/src/utilities/link';

export function RouterLink({
  url,
  external,
  children,
  ref: _ref,
  ...rest
}: LinkLikeComponentProps): JSX.Element {
  if (external || /^https?:\/\//i.test(url)) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={url} {...rest}>
      {children}
    </Link>
  );
}
